// Sign-in stays available as a normal account link while its sheet is prepared.
// The public signed-out-avatar part signals that the native component is ready.
(()=>{
 for(const host of document.querySelectorAll('[data-papiro-account-demand]')){
  if(host.dataset.initialized)continue;host.dataset.initialized='1';
  const fallback=host.querySelector('[data-account-fallback]'),template=host.querySelector('template');let pending,account;
  const prepare=()=>pending ||= (async()=>{
   const fragment=template.content.cloneNode(true);
   account=fragment.querySelector('shopify-account');
   if(!account)throw Error('Cuenta no disponible');
   account.style.position='absolute';account.style.opacity='0';account.style.pointerEvents='none';host.append(fragment);
   const deadline=performance.now()+5000;
   while(performance.now()<deadline){
    if(account.shadowRoot?.querySelector('[part~="signed-out-avatar"]')){
     account.style.removeProperty('position');account.style.removeProperty('opacity');account.style.removeProperty('pointer-events');
     const focused=document.activeElement===fallback;fallback.hidden=true;fallback.style.display='none';if(focused)account.shadowRoot.querySelector('[part~="signed-out-avatar"]')?.focus();return account;
    }
    await new Promise(r=>setTimeout(r,50));
   }
   account.remove();pending=null;throw Error('Cuenta pendiente');
  })();
  for(const event of ['pointerenter','focus'])fallback.addEventListener(event,()=>{void prepare().catch(()=>{});},{passive:true});
  fallback.addEventListener('click',async e=>{
   if(e.button||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
   e.preventDefault();fallback.setAttribute('aria-busy','true');
   try{const component=await prepare();component.shadowRoot.querySelector('[part~="signed-out-avatar"]')?.click();}
   catch{location.assign(fallback.href);}finally{fallback.removeAttribute('aria-busy');}
  });
 }
})();
